import axios from "axios";
import "./UserProfileEdit.css";
import Modal from "react-modal";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import { LoadingSpinner } from "./components/common";
import { Link, useNavigate } from "react-router-dom";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import Type from "../../../../images/icons/type.svg";
import Tele from "../../../../images/icons/tele.svg";
import Cost from "../../../../images/icons/cost1.svg";
import { useSelector, useDispatch } from 'react-redux';
import Countries from "../../../../constants/countries";
import userCategoryName from "../../../../constants/userCategory";
import Delete from "../../../../images/icons/delete.svg";
import userTypeName from "../../../../constants/userType";
import React, { useEffect, useRef, useState, createRef, useCallback } from "react";
import EmailIcon from "../../../../images/icons/email.svg";
import Company from "../../../../images/icons/company.svg";
import Payment from "../../../../images/icons/payment.svg";
import PadLock from "../../../../images/icons/padlock.png";
import Tick from "../../../../images/icons/tick-arrow.svg";
import location from "../../../../images/icons/location.svg";
import Currencies from "../../../../constants/currenciesList";
import JobTitle from "../../../../images/icons/job-title.svg";
import typeOfContract from "../../../../constants/typeOfContract";
import PostalCode from "../../../../images/icons/postal-code.svg";
import PassportlIcon from "../../../../images/icons/passport.svg";
import birthIcon from "../../../../images/icons/dat-of-birth.svg";
import PicEdit from "../../../../images/icons/profile-pic-edit.svg";
import profile_image from "../../../../images/user/Default_pfp.png";
import UserIcon from "../../../../images/icons/single-user-icon.svg";
import TypeContact from "../../../../images/icons/type-of-contact.svg";
import Clock from "../../../../images/icons/timer.svg";
import EyeIcon from "../../../../images/icons/eye-icon.svg";
import EyeCrossed from "../../../../images/icons/eye-crossed.svg";
import { reset as invoiceReset } from "../../../../features/invoice/invoiceSlice.js";
import { logout, reset, updateProfileImage } from "../../../../features/auth/authSlice";
import { setNotification } from "../../../../features/notification/notificationSlice.js";
import { reset as headerReset } from "../../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../../../features/appSettings/appSettingsSlice.js";
import { useContractTypes, useOverheadCostTypes, useUserDepartments, useUserType, useUserView, useWXCompanies } from "./useUserView";
import overHeadCostTypeConst from "../../../../constants/overHeadCostType.js";
import CompanyDocumentField from "../../elements/CompanyDocumentField.jsx";
import {
    UserProfileHeader,
    UserProfileImageCropper,
    UserProfileActions,
    PersonalInformationSection,
    EmploymentInformationSection,
    LocationInformationSection,
} from "./components";
import {
    useUserProfileForm,
    useUserProfileModals,
    useUserProfileDropdowns,
    useUserProfileImage,
} from "./hooks";
import { toastConfigs, getToastConfig } from "./utils/toastConfig";
import { handleDeletedUser, handleApiError, isDeletedUserError } from "./utils/userProfileUtils";


const ProfileDetailsEdit = (props) => {
    // Custom hooks for state management
    const {
        // Form state values
        firstName, setFirstName,
        middleName, setMiddleName,
        lastName, setLastName,
        companyName, setCompanyName,
        companyFirstName, setCompanyFirstName,
        companyLastName, setCompanyLastName,
        registrationNumber, setRegistrationNumber,
        vatId, setVatId,
        companyDocument, setCompanyDocument,
        userCategory, setUserCategory,
        userType, setUserType,
        dept, setDept,
        jobTitle, setJobTitle,
        overheadCostType, setOverheadCostType,
        wxComapny, setWxComapny,
        contract, setContract,
        monthlyhours, setMonthlyhours,
        currency, setCurrency,
        cost, setCost,
        overheadCost, setOverheadCost,
        vat, setVat,
        country, setCountry,
        state, setState,
        city, setCity,
        address, setAddress,
        postCode, setPostCode,
        mobileNo, setMobileNo,
        password, setPassword,
        passwordConfirmation, setPasswordConfirmation,
        showPassword, setShowPassword,
        selectedDate, setSelectedDate,
        joiningDate, setJoiningDate,
        passport, setPassport,
        passwordError, setPasswordError,
        passwordMatchError, setPasswordMatchError,
        passwordRef,
        passwordConfirmationRef,
    } = useUserProfileForm({
        userCategory: userCategoryName.Individual,
    });

    const {
        modalIsOpen,
        setModalIsOpen,
        showConfirmation,
        setShowConfirmation,
        showSuccessMessage,
        setShowSuccessMessage,
        closeImageCropModal,
    } = useUserProfileModals();

    const {
        userTypeDropdownOpen,
        setUserTypeDropdownOpen,
        deptDropdownOpen,
        setDeptDropdownOpen,
        wxComapnyDropdownOpen,
        setWxComapnyDropdownOpen,
        contractDropdownOpen,
        setContractDropdownOpen,
        overheadCostTypeDropdownOpen,
        setOverheadCostTypeDropdownOpen,
        currencyDropdownOpen,
        setCurrencyDropdownOpen,
        countryDropdownOpen,
        setCountryDropdownOpen,
        stateDropdownOpen,
        setStateDropdownOpen,
        dropdownVisible,
        setDropdownVisible,
        currencySearchTerm,
        setCurrencySearchTerm,
        countrySearchTerm,
        setCountrySearchTerm,
        stateSearchTerm,
        setStateSearchTerm,
        userTypeDropdownRef,
        deptDropdownRef,
        wxComapnyDropdownRef,
        contractDropdownRef,
        overheadCostTypeDropdownRef,
        currencyDropdownRef,
        countryDropdownRef,
        stateDropdownRef,
        dropdownRef,
    } = useUserProfileDropdowns();

    const {
        image,
        setImage,
        uploadedImageUrl,
        setUploadedImageUrl,
        removeProfileImage,
        setRemoveProfileImage,
        profileImage,
        setProfileImage,
        profileImageName,
        setProfileImageName,
        fileSelectIsLoading,
        setFileSelectIsLoading,
        fileInputRef,
        cropperRef,
        handleFileInputChange,
        handleFileInputCancel,
        handleProfilePicChange,
        handleCropClick,
        resizeImage,
    } = useUserProfileImage();

    // Remaining state variables (non-form related)
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);
    const [statusConfirm, setStatusConfirm] = useState({ open: false, id: null, action: null });
    const [fieldErrors, setFieldErrors] = useState({});

    const clearFieldError = useCallback((field) => {
        setFieldErrors((prev) => {
            if (!prev[field]) return prev;
            const next = { ...prev };
            delete next[field];
            return next;
        });
    }, []);
    const [userView, setUserView] = useState([]);
    const [currencyList, setCurrencyList] = useState([]);
    const [countriesList, setCountriesList] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState("");
    const [registrationDocument, setRegistrationDocument] = useState(null);
    const [states, setStates] = useState([]);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const SUPER_ADMIN = 1;
    const ADMIN = 2;
    const { appSettings } = useSelector((state) => state.appSettings);
    const url = new URL(window.location.href);
    const subdomain = url.hostname.split('.')[0];
    const capitalizedSubdomain = subdomain.charAt(0).toUpperCase() + subdomain.slice(1);
    const user = useSelector((state) => state.auth.user)
    let token = null;
    if (user) {
        if (user && user.token) {
            token = user.token;
        }
    }

    const { data: roleId = [], isLoading: userTypeLoading, isError: userTypeError } = useUserType();
    const { data: wXCompany = [], isLoading: WXCompaniesLoading, isError: WXCompaniesError } = useWXCompanies();
    const { data: userDept = [], isLoading: userDepartmentsLoading, isError: userDepartmentsError } = useUserDepartments();
    const { data: typeContract = [], isLoading: contractTypesLoading, isError: contractTypesError } = useContractTypes();
    const { data: typeOverheadCost = [], isLoading: overheadCostTypesLoading, isError: overheadCostTypesError } = useOverheadCostTypes();
    const { data: userData = [], isLoading, isError: userViewError, error } = useUserView(props.id, token);
    useEffect(() => {
        if (userData) {
            setUserView(userData);
        }
        setCurrencyList(Currencies.sourceCurrencies[0].targetCurrencies);
        const sortedCountries = Countries.slice().sort((a, b) => a.country.localeCompare(b.country));
        setCountriesList(sortedCountries);

        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                document.activeElement.blur();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [props.id]);

    useEffect(() => {
        if (!isLoading && userView && userView.role_id && userView.role_id._id) {
            if (userView.user_category) {
                setUserCategory(userView.user_category);
            }
            setUserType(userView.role_id._id);
            setFirstName(userView.first_name);
            if (userView.middle_name && userView.middle_name !== "null") {
                setMiddleName(userView.middle_name);
            }
            setLastName(userView.last_name);
            setPassport(userView.passport_no);
            setSelectedDate(new Date(userView.dob));
            if (userView.joinedDate) {
                setJoiningDate(new Date(userView.joinedDate));
            }
            if (userView.department) {
                setDept(userView.department._id);
            }
            setJobTitle(userView.job_title);
            if (userView.user_wx_comapny) {
                setWxComapny(userView.user_wx_comapny?._id);
            }
            if (userView.typeOfContract) {
                setContract(userView.typeOfContract._id);
            }
            if (userView.overHeadCostType) {
                setOverheadCostType(userView.overHeadCostType._id);
            }
            setCurrency(userView.payment_currency);
            setCost(userView.cost);
            setMonthlyhours(userView.monthly_hours);
            setOverheadCost(userView.overhead_cost);
            setVat(userView.vat);
            setCompanyName(userView.company_name);
            if (userView.company_first_name) {
                setCompanyFirstName(userView.company_first_name);
                if (userView.company_last_name) {
                    setCompanyLastName(userView.company_last_name);
                }
            }
            setPassword("");
            setVatId(userView.vat_number);
            if (userView.company_document) {
                setCompanyDocument(userView.company_document);
            }
            setRegistrationNumber(userView.register_number);
            if (userView.country) {
                setCountry(userView.country);
                // Set states based on country
                const countryData = countriesList.find((c) => c.country === userView.country);
                setStates(countryData?.states || []);
            }
            if (userView.state) {
                setState(userView.state);
            }
            setCity(userView.city);
            setMobileNo(userView.mobile_no);
            setPostCode(userView.pincode);
            setAddress(userView.address);
        }
    }, [isLoading, userView, countriesList]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownVisible(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (wXCompany.length === 1 && !wxComapny) {
            setWxComapny(wXCompany[0]._id);
        }
    }, [wXCompany]);

    useEffect(() => {
        if (userViewError && isDeletedUserError(error)) {
            handleApiError(error, dispatch, navigate);
        }
    }, [userViewError, error, dispatch, navigate]);


    const handleCurrencySearchInputChange = (e) => {
        setCurrencySearchTerm(e.target.value);
    };

    const filteredCurrencies = currencyList.filter((currency) => {
        const currencyName = currency.currencyCode
            && `${currency.currencyCode} (${currency.currencyName})`;
        return currencyName.toLowerCase().includes(currencySearchTerm.toLowerCase());
    });

    const handleCountrySearchInputChange = (e) => {
        setCountrySearchTerm(e.target.value);
    };

    const filteredCountries = countriesList.filter((country) => {
        return country.country.toLowerCase().includes(countrySearchTerm.toLowerCase());
    });

    const handleStateSearchInputChange = (e) => {
        setStateSearchTerm(e.target.value);
    };

    const selectedCountry = countriesList.find((c) => c.country === country);
    const filteredStates = selectedCountry?.states?.filter((stateObj) =>
        stateObj.state.toLowerCase().includes(stateSearchTerm.toLowerCase())
    );

    // handleProfilePicChange is provided by useUserProfileImage hook

    const handleDropdown = () => {
        setDropdownVisible(!dropdownVisible);
    }

    // handleFileInputCancel is provided by useUserProfileImage hook

    const handleClickOutsideDropdown = (event) => {
        const isClickInsideUserTypeDropdown = userTypeDropdownRef.current && userTypeDropdownRef.current.contains(event.target);
        const isClickInsideDeptDropdown = deptDropdownRef.current && deptDropdownRef.current.contains(event.target);
        const isClickInsideWXComapnyDropdown = wxComapnyDropdownRef.current && wxComapnyDropdownRef.current.contains(event.target);
        const isClickInsideContractDropdown = contractDropdownRef.current && contractDropdownRef.current.contains(event.target);
        const isClickInsideOverheadCostTypeDropdown = overheadCostTypeDropdownRef.current && overheadCostTypeDropdownRef.current.contains(event.target);
        const isClickInsideCurrencyDropdown = currencyDropdownRef.current && currencyDropdownRef.current.contains(event.target);
        const isClickInsideCountryDropdown = countryDropdownRef.current && countryDropdownRef.current.contains(event.target);
        const isClickInsideStateDropdown = stateDropdownRef.current && stateDropdownRef.current.contains(event.target);
        if (!isClickInsideUserTypeDropdown) {
            setUserTypeDropdownOpen(false);
        }
        if (!isClickInsideDeptDropdown) {
            setDeptDropdownOpen(false);
        }
        if (!isClickInsideWXComapnyDropdown) {
            setWxComapnyDropdownOpen(false);
        }
        if (!isClickInsideContractDropdown) {
            setContractDropdownOpen(false);
        }
        if (!isClickInsideOverheadCostTypeDropdown) {
            setOverheadCostTypeDropdownOpen(false);
        }
        if (!isClickInsideCurrencyDropdown) {
            setCurrencyDropdownOpen(false);
        }
        if (!isClickInsideCountryDropdown) {
            setCountryDropdownOpen(false);
        }
        if (!isClickInsideStateDropdown) {
            setStateDropdownOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutsideDropdown);
        return () => {
            document.removeEventListener('click', handleClickOutsideDropdown);
        };
    }, []);

    // Wrapper for handleFileInputChange to open modal
    const handleFileInputChangeWrapper = useCallback((event) => {
        handleFileInputChange(event, () => {
            setModalIsOpen(true);
        });
    }, [handleFileInputChange, setModalIsOpen]);

    // Wrapper for handleCropClick to close modal
    const handleCropClickWrapper = useCallback(() => {
        handleCropClick(() => {
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
            setFileSelectIsLoading(false);
            setModalIsOpen(false);
        });
    }, [handleCropClick, setFileSelectIsLoading, setModalIsOpen]);

    // Attach event listeners to the file input
    useEffect(() => {
        const inputElement = fileInputRef.current;
        if (!inputElement) return;

        const handleChange = () => {
            handleFileInputChangeWrapper({ target: { files: inputElement.files } });
        };

        const handleCancel = () => {
            handleFileInputCancel();
        };

        inputElement.addEventListener('change', handleChange);
        inputElement.addEventListener('cancel', handleCancel);

        return () => {
            inputElement.removeEventListener('change', handleChange);
            inputElement.removeEventListener('cancel', handleCancel);
        };
    }, [handleFileInputChangeWrapper, handleFileInputCancel]);

    const closeModal = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
        setFileSelectIsLoading(false);
        setModalIsOpen(false);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setPasswordMatchError("");
        setPasswordError("");

        // Required field validation
        const isBusinessType = [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userCategory);
        const errors = {};
        if (isBusinessType) {
            if (!companyName?.trim()) errors.companyName = true;
            if (!companyFirstName?.trim()) errors.companyFirstName = true;
            if (!registrationNumber?.trim()) errors.registrationNumber = true;
        } else {
            if (!firstName?.trim()) errors.firstName = true;
            if (!lastName?.trim()) errors.lastName = true;
        }
        if (!passport?.trim()) errors.passport = true;
        if (!userType) errors.userType = true;
        if (!dept) errors.dept = true;
        if (!jobTitle?.trim()) errors.jobTitle = true;
        if (!overheadCostType) errors.overheadCostType = true;
        if (!wxComapny) errors.wxComapny = true;
        if (!contract) errors.contract = true;
        if (monthlyhours === null || monthlyhours === undefined || String(monthlyhours).trim() === '') errors.monthlyhours = true;
        if (!currency) errors.currency = true;
        if (cost === null || cost === undefined || String(cost).trim() === '') errors.cost = true;
        if (overheadCost === null || overheadCost === undefined || String(overheadCost).trim() === '') errors.overheadCost = true;
        if (vat === null || vat === undefined || String(vat).trim() === '') errors.vat = true;
        if (!country) errors.country = true;
        if (!city?.trim()) errors.city = true;
        if (!address?.trim()) errors.address = true;
        if (!mobileNo?.trim()) errors.mobileNo = true;

        if (Object.keys(errors).length > 0) {
            setFieldErrors(errors);
            // Scroll to first error field
            const fieldOrder = isBusinessType
                ? ['companyName', 'companyFirstName', 'registrationNumber', 'passport', 'userType', 'dept', 'jobTitle', 'overheadCostType', 'wxComapny', 'contract', 'monthlyhours', 'currency', 'cost', 'overheadCost', 'vat', 'country', 'city', 'address', 'mobileNo']
                : ['firstName', 'lastName', 'passport', 'userType', 'dept', 'jobTitle', 'overheadCostType', 'wxComapny', 'contract', 'monthlyhours', 'currency', 'cost', 'overheadCost', 'vat', 'country', 'city', 'address', 'mobileNo'];
            const firstError = fieldOrder.find((f) => errors[f]);
            if (firstError) {
                const el = document.getElementById(`field-${firstError}`);
                if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            return;
        }
        setFieldErrors({});
        const mobileNoRegex = /^[+\d]+$/;
        if (!mobileNoRegex.test(mobileNo)) {

            toast.error("It's not a valid phone number", toastConfigs.error);
            return;
        }
        const costRegex = /^\d+(\.\d{1,2})?$/;
        if (!costRegex.test(cost)) {
            toast.error("Cost should contain numbers only", toastConfigs.error);
            return;
        }
        if (!costRegex.test(overheadCost)) {
            toast.error("OverHeadCost should contain numbers only", toastConfigs.error);
            return;
        }
        const vatRegex = /^\d+|%$/;
        if (!vatRegex.test(vat)) {
            toast.error("VAT should contain numbers or '%' symbol only", toastConfigs.error);
            return;
        }

        if (password) {
            if (passwordConfirmation === "") {
                setPasswordMatchError("You Need to confirm the Password");
                passwordConfirmationRef.current.focus();
                return;
            } else if (password !== passwordConfirmation) {
                setPasswordMatchError("Passwords do not match");
                passwordConfirmationRef.current.focus();
                return;
            }
            const passwordRegex =
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#\$%\^&\*\(\)_\+\-\.\/:;<=>?@[\\\]^_`{|}~])[A-Za-z\d!@#\$%\^&\*\(\)_\+\-\.\/:;<=>?@[\\\]^_`{|}~]{8,}$/;
            if (!passwordRegex.test(password)) {
                setPasswordError("Invalid password format");
                toast.error("Password must be at least 8 charachters long and include atleast one uppercase letter ,one lowercase letter,one digit and one special character from the set !@#$%^&*()_+,-/:;<=>?@_'[\]{|}~", toastConfigs.error);
                passwordRef.current.focus();
                return;
            }
        }

        const previousUserType = userView?.role_id?._id;
        const fileExtension = profileImageName
            ? profileImageName.name.split(".").pop()
            : "";
        const uniqueSuffix = Date.now() + "-" + Math.round(Math.random() * 1e9);
        const profile_img_fileName = profileImageName
            ? `${profileImageName.name
                .split(".")
                .shift()}_${uniqueSuffix}.${fileExtension}`
            : null;

        if (lastName) {
            if (lastName.length <= 1) {

                toast.error("A last name should have more than one character.", toastConfigs.error);
                return;

            }
        }

        const requestData = {
            first_name: [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userCategory) ? "" : firstName,
            middle_name: [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userCategory) ? "" : middleName,
            last_name: [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userCategory) ? "" : lastName,
            user_wx_comapny: wxComapny,
            mobile_no: mobileNo,
            passport_no: passport,
            password,
            role_id: userType,
            user_category: userCategory,
            department: dept,
            typeOfContract: contract,
            monthlyhours: monthlyhours,
            overHeadCostType: overheadCostType,
            job_title: jobTitle,
            payment_currency: currency,
            cost,
            overhead_cost: overheadCost,
            vat,
            address,
            pincode: postCode,
            dob: selectedDate,
            joinedDate: joiningDate,
            country,
            state,
            city,
            company_name: [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userCategory) ? companyName : "",
            company_first_name: [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userCategory) ? companyFirstName : "",
            company_last_name: [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userCategory) ? companyLastName : "",
            vat_number: [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userCategory) ? vatId : "",
            register_number: [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userCategory) ? registrationNumber : "",
        };
        if (removeProfileImage) {
            requestData.profile_image = null;
        }

        if (profileImage) {
            requestData.profile_image = profile_img_fileName;
        }

        // Create a new FormData object
        const formData = new FormData();
        // Append the profile image to the form data
        formData.append("company_document", registrationDocument);

        // Append the other request data to the form data
        for (let key in requestData) {
            formData.append(key, requestData[key]);
        }

        try {
            setIsSubmitLoading(true);
            const response = await axios.put(`/api/user/update/${props.id}`, formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
            if (profileImage) {
                const resizedImage = await resizeImage(profileImage, 500);

                const base64Image = resizedImage.split(',')[1];
                const blob = await fetch(`data:image/png;base64,${base64Image}`).then(res => res.blob());

                // Change to 'image/png' if needed

                const uploadFormData = new FormData();
                uploadFormData.append("profile_image", blob, profile_img_fileName);

                try {
                    await axios.post("/api/uploads/profileImage", uploadFormData);
                } catch (uploadError) {
                    console.log(uploadError);
                    global.config.slackMessage(uploadError.toString());
                    if (handleApiError(uploadError, dispatch, navigate)) {
                        return;
                    }
                    toast.error('Something went wrong with the profile image upload!', toastConfigs.short);
                }
            }
            if (user._id === props.id) {
                if (profileImage) {
                    dispatch(updateProfileImage(profile_img_fileName));
                }
                if (removeProfileImage) {
                    dispatch(updateProfileImage(null));
                }
            }
            if (user._id === props.id && previousUserType !== userType && (user.userType === SUPER_ADMIN || user.userType === ADMIN)) {
                localStorage.removeItem("user");
                dispatch(logout());
                dispatch(reset());
                dispatch(invoiceReset());
                dispatch(headerReset());
                dispatch(appSettingsReset());
                toast.success("User details updated successfully!", toastConfigs.success);
                global.config.activityLog(
                    window.location.href,
                    "User",
                    `User "${userCategory && [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userCategory) ? companyName : firstName} " Details updated successfully!`
                );
                return;
            }

            const data = response.data;
            if (data.status === "error") {
                toast.error('Something went wrong while updating User Details!', toastConfigs.short);
            } else {
                global.config.activityLog(
                    window.location.href,
                    "User",
                    `User "${userCategory && [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userCategory) ? companyName : firstName} " Details updated successfully!`
                );
                toast.success("User details updated successfully!!!", toastConfigs.success);
                dispatch(setNotification(Date.now()));
                props.onCancel();
            }
        } catch (error) {
            console.log(error);
            global.config.slackMessage(error.toString());
            if (handleApiError(error, dispatch, navigate)) {
                return;
            }
            alert("Something went wrong");
        } finally {
            props.setTimeStamp(Date.now());
            setIsSubmitLoading(false);
        }
    };

    const allowedExtensions = ["pdf", "doc", "docx", "msword", "xls", "xlsx", "csv"];
    const handleRegistrationDocChange = (event) => {
        const selectedFile = event.target.files[0];

        if (selectedFile) {
            const fileExtension = selectedFile.name.split(".").pop().toLowerCase();
            if (allowedExtensions.includes(fileExtension)) {
                setRegistrationDocument(selectedFile);
            } else {
                toast.error("Invalid file format. Allowed formats are pdf, doc, docx, msword, xls, xlsx, csv.!!", toastConfigs.long);
                // Optionally, you can clear the input
                event.target.value = null;
            }
        }
    };

    const downloadCompyDoc = async (compyFile) => {
        try {

            const response = await axios.get(`/api/user/compyDoc/download/${compyFile}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                responseType: "blob",
            }, {
                responseType: "blob",
            });
            const pdfBlob = new Blob([response.data], { type: "application/pdf" });
            saveAs(pdfBlob, `${compyFile}`);

        } catch (error) {

            global.config.slackMessage(error.toString());
            console.error(error);
            if (handleApiError(error, dispatch, navigate)) {
                return;
            }
            toast.error('Error Downloading Company DOC', toastConfigs.short);
            // Handle error

        }
    };

    const StatusChangeActive = (id) => {
        setStatusConfirm({ open: true, id, action: 'deactivate' });
    };

    const StatusChangeInactive = (id) => {
        setStatusConfirm({ open: true, id, action: 'activate' });
    };

    const handleConfirmStatusChange = async () => {
        const { id, action } = statusConfirm;
        setStatusConfirm({ open: false, id: null, action: null });
        const displayName = userCategory && [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userCategory) ? companyName : firstName;
        try {
            setIsSubmitLoading(true);
            await axios.get(`/api/user/status-change/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (action === 'deactivate') {
                toast.success(`${displayName}'s account has been deactivated successfully!`, toastConfigs.success);
                global.config.activityLog(window.location.href, "User", `${displayName}'s account has been deactivated successfully!`);
                setUserView((prev) => prev._id === id ? { ...prev, is_active: false } : prev);
            } else {
                toast.success(`${displayName}'s account has been activated successfully!`, toastConfigs.success);
                global.config.activityLog(window.location.href, "User", `${displayName}'s account has been activated successfully!`);
                setUserView((prev) => prev._id === id ? { ...prev, is_active: true } : prev);
            }
            dispatch(setNotification(Date.now()));
        } catch (error) {
            const verb = action === 'deactivate' ? 'deactivating' : 'activating';
            console.log(`Something went wrong while ${verb}: `, error);
            toast.error(`Something went wrong while ${verb} ${displayName}'s account`, toastConfigs.error);
            global.config.activityLog(window.location.href, "User", `Something went wrong while ${verb} ${displayName}'s account!`);
            global.config.slackMessage(error.toString());
            if (handleApiError(error, dispatch, navigate)) return;
        } finally {
            setIsSubmitLoading(false);
        }
    };

    const handleDeleteClick = (id) => {
        setSelectedUserId(id);
        setShowConfirmation(true);
    };

    const handleConfirmationOk = async () => {
        try {
            await axios.get(`/api/delete/user/${selectedUserId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            toast.success("User removed successfully", toastConfigs.short);
            navigate("/user/myteam/list");
        } catch (error) {
            console.log(error);
            global.config.slackMessage(error.toString());
            if (handleApiError(error, dispatch, navigate)) {
                return;
            }
            toast.error("Something went wrong", toastConfigs.short);
        }
    };
    // Define selectedDate and handleDateChange
    // Set an initial date

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const handleJoiningDateChange = (date) => {
        setJoiningDate(date);
    };

    const handleToggleCountryDropdown = () => {
        setCountrySearchTerm('');
        setCountryDropdownOpen(!countryDropdownOpen);
    };

    const handleCountryChange = (selectedCountry) => {
        setCountry(selectedCountry);
        setState("");
        setCountryDropdownOpen(false);
        // Update states based on selected country
        const countryData = countriesList.find((c) => c.country === selectedCountry);
        setStates(countryData?.states || []);
    };

    const handleStateChange = (event) => {
        setState(event.target.value);
    };

    const handleCancel = () => {
        props.onCancel();
    };

    const numberInputOnWheelPreventChange = (e) => {
        // Prevent the input value change
        e.target.blur()

        // Prevent the page/container scrolling
        e.stopPropagation()

        setTimeout(() => {
            e.target.focus()
        }, 0)
    }


    return (
        <div className="profile-details-edit">
            <form onSubmit={handleSubmit} noValidate>
                <UserProfileHeader
                    isLoading={isLoading}
                    userView={userView}
                    firstName={firstName}
                    middleName={middleName}
                    lastName={lastName}
                    companyName={companyName}
                    companyFirstName={companyFirstName}
                    companyLastName={companyLastName}
                    userType={userType}
                    user={user}
                    userCategory={userCategory}
                    userCategoryName={userCategoryName}
                    uploadedImageUrl={uploadedImageUrl}
                    removeProfileImage={removeProfileImage}
                    fileSelectIsLoading={fileSelectIsLoading}
                    dropdownVisible={dropdownVisible}
                    dropdownRef={dropdownRef}
                    isSubmitLoading={isSubmitLoading}
                    onProfilePicChange={handleProfilePicChange}
                    onDropdownToggle={handleDropdown}
                    onRemoveProfileImageChange={setRemoveProfileImage}
                    StatusChangeActive={StatusChangeActive}
                    StatusChangeInactive={StatusChangeInactive}
                    SUPER_ADMIN={SUPER_ADMIN}
                    ADMIN={ADMIN}
                />

                <input
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    ref={fileInputRef}

                />

                <UserProfileImageCropper
                    isOpen={modalIsOpen}
                    image={image}
                    cropperRef={cropperRef}
                    onCrop={handleCropClickWrapper}
                    onClose={closeModal}
                />

                <UserProfileActions
                    showConfirmation={showConfirmation}
                    showSuccessMessage={showSuccessMessage}
                    onConfirmDelete={handleConfirmationOk}
                    onCancelDelete={() => setShowConfirmation(false)}
                />

                <Modal
                    className="delete-modal"
                    isOpen={statusConfirm.open}
                    onRequestClose={() => setStatusConfirm({ open: false, id: null, action: null })}
                    contentLabel="Confirm Status Change"
                    style={{
                        content: {
                            height: "41%",
                            width: "30%",
                            position: "fixed",
                            top: "36%",
                            left: "50%",
                        },
                    }}
                >
                    <div className="delete-modal-content">
                        <h2>
                            {statusConfirm.action === 'deactivate' ? 'Deactivate Account' : 'Activate Account'}
                        </h2>
                        <p>
                            {statusConfirm.action === 'deactivate'
                                ? 'Are you sure you want to deactivate this account? The user will lose access immediately.'
                                : 'Are you sure you want to activate this account? The user will regain access immediately.'}
                        </p>
                        <div className="delete-modal-buttons">
                            <button
                                className={statusConfirm.action === 'deactivate' ? 'buttons-rejected' : 'buttons-approved'}
                                onClick={handleConfirmStatusChange}
                            >
                                {statusConfirm.action === 'deactivate' ? 'Yes, Deactivate' : 'Yes, Activate'}
                            </button>
                            <button onClick={() => setStatusConfirm({ open: false, id: null, action: null })}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </Modal>

                <div className="information-outer-section">
                    <PersonalInformationSection
                        isLoading={isLoading}
                        fieldErrors={fieldErrors}
                        clearFieldError={clearFieldError}
                        userCategory={userCategory}
                        userCategoryName={userCategoryName}
                        firstName={firstName}
                        setFirstName={setFirstName}
                        middleName={middleName}
                        setMiddleName={setMiddleName}
                        lastName={lastName}
                        setLastName={setLastName}
                        companyName={companyName}
                        setCompanyName={setCompanyName}
                        companyFirstName={companyFirstName}
                        setCompanyFirstName={setCompanyFirstName}
                        companyLastName={companyLastName}
                        setCompanyLastName={setCompanyLastName}
                        registrationNumber={registrationNumber}
                        setRegistrationNumber={setRegistrationNumber}
                        vatId={vatId}
                        setVatId={setVatId}
                        companyDocument={companyDocument}
                        userView={userView}
                        downloadCompyDoc={downloadCompyDoc}
                        handleRegistrationDocChange={handleRegistrationDocChange}
                        email={userView.email}
                        password={password}
                        setPassword={setPassword}
                        passwordConfirmation={passwordConfirmation}
                        setPasswordConfirmation={setPasswordConfirmation}
                        showPassword={showPassword}
                        setShowPassword={setShowPassword}
                        passwordError={passwordError}
                        passwordMatchError={passwordMatchError}
                        passwordRef={passwordRef}
                        passwordConfirmationRef={passwordConfirmationRef}
                        selectedDate={selectedDate}
                        handleDateChange={handleDateChange}
                        joiningDate={joiningDate}
                        handleJoiningDateChange={handleJoiningDateChange}
                        passport={passport}
                        setPassport={setPassport}
                        appSettings={appSettings}
                        user={user}
                        SUPER_ADMIN={SUPER_ADMIN}
                        ADMIN={ADMIN}
                    />

                    <EmploymentInformationSection
                        isLoading={isLoading}
                        fieldErrors={fieldErrors}
                        clearFieldError={clearFieldError}
                        userCategory={userCategory}
                        userCategoryName={userCategoryName}
                        setUserCategory={setUserCategory}
                        userView={userView}
                        userType={userType}
                        setUserType={setUserType}
                        userTypeDropdownOpen={userTypeDropdownOpen}
                        setUserTypeDropdownOpen={setUserTypeDropdownOpen}
                        userTypeDropdownRef={userTypeDropdownRef}
                        roleId={roleId}
                        dept={dept}
                        setDept={setDept}
                        deptDropdownOpen={deptDropdownOpen}
                        setDeptDropdownOpen={setDeptDropdownOpen}
                        deptDropdownRef={deptDropdownRef}
                        userDept={userDept}
                        jobTitle={jobTitle}
                        setJobTitle={setJobTitle}
                        overheadCostType={overheadCostType}
                        typeOverheadCost={typeOverheadCost}
                        wxComapny={wxComapny}
                        setWxComapny={setWxComapny}
                        wxComapnyDropdownOpen={wxComapnyDropdownOpen}
                        setWxComapnyDropdownOpen={setWxComapnyDropdownOpen}
                        wxComapnyDropdownRef={wxComapnyDropdownRef}
                        wXCompany={wXCompany}
                        capitalizedSubdomain={capitalizedSubdomain}
                        contract={contract}
                        setContract={setContract}
                        contractDropdownOpen={contractDropdownOpen}
                        setContractDropdownOpen={setContractDropdownOpen}
                        contractDropdownRef={contractDropdownRef}
                        typeContract={typeContract}
                        monthlyhours={monthlyhours}
                        setMonthlyhours={setMonthlyhours}
                        currency={currency}
                        setCurrency={setCurrency}
                        currencyDropdownOpen={currencyDropdownOpen}
                        setCurrencyDropdownOpen={setCurrencyDropdownOpen}
                        currencyDropdownRef={currencyDropdownRef}
                        currencyList={currencyList}
                        currencySearchTerm={currencySearchTerm}
                        handleCurrencySearchInputChange={handleCurrencySearchInputChange}
                        filteredCurrencies={filteredCurrencies}
                        cost={cost}
                        setCost={setCost}
                        overheadCost={overheadCost}
                        setOverheadCost={setOverheadCost}
                        vat={vat}
                        setVat={setVat}
                        user={user}
                        SUPER_ADMIN={SUPER_ADMIN}
                        ADMIN={ADMIN}
                        numberInputOnWheelPreventChange={numberInputOnWheelPreventChange}
                    />

                    <LocationInformationSection
                        isLoading={isLoading}
                        fieldErrors={fieldErrors}
                        clearFieldError={clearFieldError}
                        country={country}
                        setCountry={setCountry}
                        countryDropdownOpen={countryDropdownOpen}
                        setCountryDropdownOpen={setCountryDropdownOpen}
                        countryDropdownRef={countryDropdownRef}
                        handleToggleCountryDropdown={handleToggleCountryDropdown}
                        handleCountryChange={handleCountryChange}
                        countriesList={countriesList}
                        countrySearchTerm={countrySearchTerm}
                        handleCountrySearchInputChange={handleCountrySearchInputChange}
                        filteredCountries={filteredCountries}
                        state={state}
                        setState={setState}
                        stateDropdownOpen={stateDropdownOpen}
                        setStateDropdownOpen={setStateDropdownOpen}
                        stateDropdownRef={stateDropdownRef}
                        stateSearchTerm={stateSearchTerm}
                        setStateSearchTerm={setStateSearchTerm}
                        handleStateSearchInputChange={handleStateSearchInputChange}
                        filteredStates={filteredStates}
                        states={states}
                        city={city}
                        setCity={setCity}
                        address={address}
                        setAddress={setAddress}
                        postCode={postCode}
                        setPostCode={setPostCode}
                        mobileNo={mobileNo}
                        setMobileNo={setMobileNo}
                    />
                </div>
                <div className="save-button-sec">
                    <a
                        className="cancel-btn"
                        onClick={(e) => {
                            e.preventDefault();
                            if (!isSubmitLoading) {
                                handleCancel();
                            }
                        }} >Cancel
                    </a>
                    <button type="submit" className="save-btn" disabled={isSubmitLoading}>
                        {isSubmitLoading ?
                            <div className="outter-load-table">
                                <LoadingSpinner
                                    color="white"
                                    height={38}
                                    width={40}
                                    radius={9}
                                />
                            </div> :
                            <>
                                <img src={Tick} alt="arrow" /> Save Changes
                            </>
                        }
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ProfileDetailsEdit;